module.exports = __webpack_public_path__ + "img/lg_full_color_IM_4x 1.76c74c5d.png";